export const actions = {
  clearInterests({ commit }) {
    return new Promise((resolve) => {
      commit('CLEAR_INTERESTS');
      resolve();
    });
  },
};
